/**
 * Generated by orval v8.20.0.
 * Do not edit manually.
 * Hub API v2.0.0.
 */

import type { HttpContext, HttpEvent, HttpParams } from '@angular/common/http';
import { HttpResponse as AngularHttpResponse, HttpClient, HttpHeaders } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

import type { AgencyOrdersExport200, AgencyOrdersExportBody } from '../../models';

interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?:
    | HttpParams
    | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: { includeHeaders?: string[] } | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};

@Injectable({ providedIn: 'root' })
export class OrdersService {
  private readonly http = inject(HttpClient);
  /**
   * Requests a spreadsheet of the session consumer's orders first issued within the window, both days included, mailed to the recipients. The export runs in the background, so a 200 confirms it was requested, not that the mail was sent; the returned `event_id` identifies the request should it never arrive. The same export asked for again while one is still running is not run twice. The window may span at most 366 days. Managers of the consumer's super agency only: the export covers every agency of the consumer, whichever agency asks, so a sub-agency's manager may not mail it out.<br><br>Replaces `POST /v1.2/OrderExport` of the legacy API: `issuingDateFrom`, `issuingDateTo` and `recipientEmails` are `issuing_date_from`, `issuing_date_to` and `recipient_emails`; the reply is the event id rather than `{ok: true}`; and sub-agency managers, whom the legacy let through, are refused.
   * @summary Export the consumer's orders
   */
  agencyOrdersExport<TData = AgencyOrdersExport200>(
    agencyOrdersExportBody: AgencyOrdersExportBody,
    options?: HttpClientBodyOptions
  ): Observable<TData>;
  agencyOrdersExport<TData = AgencyOrdersExport200>(
    agencyOrdersExportBody: AgencyOrdersExportBody,
    options?: HttpClientEventOptions
  ): Observable<HttpEvent<TData>>;
  agencyOrdersExport<TData = AgencyOrdersExport200>(
    agencyOrdersExportBody: AgencyOrdersExportBody,
    options?: HttpClientResponseOptions
  ): Observable<AngularHttpResponse<TData>>;
  agencyOrdersExport<TData = AgencyOrdersExport200>(
    agencyOrdersExportBody: AgencyOrdersExportBody,
    options?: HttpClientObserveOptions
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
        `${environment.hubApiUrl}/agency/orders/export`,
        agencyOrdersExportBody,
        {
          ...(options as Omit<NonNullable<typeof options>, 'observe'>),
          observe: 'events',
        }
      );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
        `${environment.hubApiUrl}/agency/orders/export`,
        agencyOrdersExportBody,
        {
          ...(options as Omit<NonNullable<typeof options>, 'observe'>),
          observe: 'response',
        }
      );
    }

    return this.http.post<TData>(
      `${environment.hubApiUrl}/agency/orders/export`,
      agencyOrdersExportBody,
      {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
}
